import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ReactPortal } from 'gu-ui-kit'
import Notification from 'modules/Notifications/Notification'
import styles from 'modules/Notifications/notifications.module.scss'
import { notificationShow } from 'modules/Notifications/actions'

const Notifications = () => {
  const dispatch = useDispatch()

  // этот код отображает flash message, которые может передать бэкенд при первой загрузке документа. единожды!
  useEffect(
    () =>
      window.flashes?.forEach((flash) =>
        dispatch(notificationShow({ ...flash })),
      ),
    [],
  )

  const { notifications } = useSelector(({ notifications }) => notifications)

  return notifications.length > 0 ? (
    <ReactPortal wrapperId={'notification-portal'}>
      <div className={styles['notifications']}>
        {notifications.map((notification) => (
          <Notification
            key={'notification-component-' + notification.UUID}
            {...notification}
          />
        ))}
      </div>
    </ReactPortal>
  ) : null
}

export default Notifications
